var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"column is-8 is-offset-2 container-box has-text-white"},[_c('div',{staticClass:"column is-full is-paddingless"},[_c('Timeline')],1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }